import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ListDeploymentService } from 'app/lists/list-deployment.service';

@Component({
  selector: 'cc-list-tool-bar',
  templateUrl: './list-tool-bar.component.html',
  styleUrls: ['./list-tool-bar.component.scss', '../../../styles/components/tool-bar.component.scss'],
})
export class ListToolBarComponent {
  @Input() canDeployLists = false;
  @Input() selectedItemIds: string[] = [];
  @Output() readonly createNewItem = new EventEmitter<void>();
  @Output() readonly deleteSelectedItems = new EventEmitter<void>();
  isInDeployMode = false;

  constructor(private readonly listDeploymentService: ListDeploymentService) {}

  ngOnInit(): void {
    this.listDeploymentService.activeDeployMode$.subscribe((activeDeployMode) => {
      this.isInDeployMode = Boolean(activeDeployMode);
    });
  }

  startDeployMode() {
    this.listDeploymentService.startDeployMode(this.selectedItemIds);
    this.isInDeployMode = true;
  }

  startUndeployMode() {
    this.listDeploymentService.startUndeployMode(this.selectedItemIds);
  }
}
